import { render, staticRenderFns } from "./Pikachu.vue?vue&type=template&id=105502c2&scoped=true"
import script from "./Pikachu.vue?vue&type=script&lang=js"
export * from "./Pikachu.vue?vue&type=script&lang=js"
import style0 from "./Pikachu.vue?vue&type=style&index=0&id=105502c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_cache-loader@4.1.0_webpack@4.47.0__css-load_9a5d4250dd08d9b6c6ab534d53b24d01/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105502c2",
  null
  
)

export default component.exports